import React from 'react';
interface LogoProps {
  tone?: 'dark' | 'light';
}
export function Logo({
  tone = 'dark'
}: LogoProps) {
  return <span className={`inline-flex items-center gap-2.5 ${tone === 'dark' ? 'text-ink' : 'text-white'}`} data-id="element-317" data-mp="ybxs67d8h1w6">
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden data-id="element-318" data-mp="tai8aimsl1fd">
        <rect x="0" y="12" width="11" height="12" fill="currentColor" data-id="element-319" data-mp="od8d0mcq1vjm" />
        <rect x="12" y="12" width="12" height="12" fill="currentColor" data-id="element-320" data-mp="of2v7swlz9k0" />
        <rect x="12" y="0" width="12" height="11" fill="#EA4E1B" data-id="element-321" data-mp="kcg1tnkahgkp" />
      </svg>
      <span className="whitespace-nowrap text-[19px] font-semibold tracking-[-0.03em]" data-id="element-322" data-mp="fjmwoykws683">Atelier Volta</span>
    </span>;
}